// extracted by mini-css-extract-plugin
export default {"block":"afPfTP","alignXLeft":"bfPfTP","alignXCenter":"cfPfTP","alignXRight":"dfPfTP","alignYTop":"efPfTP","alignYCenter":"ffPfTP","alignYBottom":"gfPfTP"};